import { useEffect, useRef } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { isHomePage } from '@confluence/named-routes/entry-points/routes-utils.ts';
import { useIsCurrentPageLive } from '@confluence/live-pages-utils/entry-points/useIsCurrentPageLive.ts';
import { useTransitionId } from '@confluence/route-manager/entry-points/RouteState.ts';

import {
	useNthUserOrientationState,
	useNthUserOrientationActions,
} from '../hooks/useNthUserOrientationStore.ts';

export const NthUserOrientation = () => {
	const { active, step } = useNthUserOrientationState();
	const { reset } = useNthUserOrientationActions();
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const transitionId = useTransitionId();
	const initialTransitionIdRef = useRef<number | null>(null);
	const isLiveDoc = useIsCurrentPageLive();
	const isHome = isHomePage();
	const onEligiblePage = isLiveDoc || isHome;

	// Set the initial transition ID when the tour becomes active on an eligible page
	useEffect(() => {
		if (active && onEligiblePage && initialTransitionIdRef.current === null) {
			initialTransitionIdRef.current = transitionId;
		}
	}, [active, onEligiblePage, transitionId]);

	// Detect navigation away from the original page and reset the tour
	useEffect(() => {
		if (!active || initialTransitionIdRef.current === null) {
			return;
		}
		if (transitionId > initialTransitionIdRef.current) {
			createAnalyticsEvent({
				type: 'sendTrackEvent',

				data: {
					action: 'abandoned',
					actionSubject: 'tour',
					actionSubjectId: 'nthUserOrientation',
					source: isLiveDoc ? 'live-doc' : 'home',
					attributes: {
						step,
					},
				},
			}).fire();
			reset();
		}
	}, [active, createAnalyticsEvent, isLiveDoc, reset, step, transitionId]);

	return null;
};
